export default __webpack_public_path__ + "static/tpmr-fb2fb309c12eaf91d1057df3ca11be02.png";